// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsSection__ReplyInput = require("../../common/Components/ConversationsSection__ReplyInput.bs.js");
let ConversationPageNotAnonymousWarning = require("./ConversationPageNotAnonymousWarning.bs.js");
let ConversationPageConversationMessages = require("./ConversationPageConversationMessages.bs.js");
let ConversationPageConversation_conversation_graphql = require("../../../__generated__/ConversationPageConversation_conversation_graphql.bs.js");
let ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");

let convertFragment = ConversationPageConversation_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationPageConversation_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversation_conversation_graphql.node, convertFragment, fRef);
}

let ConversationFragment_conversationVisibilityV5_decode = ConversationPageConversation_conversation_graphql.Utils.conversationVisibilityV5_decode;

let ConversationFragment_conversationVisibilityV5_fromString = ConversationPageConversation_conversation_graphql.Utils.conversationVisibilityV5_fromString;

let ConversationFragment = {
  conversationVisibilityV5_decode: ConversationFragment_conversationVisibilityV5_decode,
  conversationVisibilityV5_fromString: ConversationFragment_conversationVisibilityV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageConversation(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationPageConversation_conversation_graphql.node, convertFragment, props.conversation);
  let match = conversation.conversationContext;
  let match$1 = conversation.visibility;
  let tmp;
  tmp = match$1 === "PUBLIC";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationPageConversationMessages.make, {
          conversation: conversation.fragmentRefs
        })
      }),
      match !== undefined ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ConversationPageNotAnonymousWarning.make, {
            conversationContext: match.fragmentRefs
          }),
          className: "mt-4 mb-8 p-4"
        }) : null,
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(ConversationsSection__ReplyInput.make, {
          focusOnMount: false,
          conversation: conversation.fragmentRefs,
          withAvatar: false,
          showVisibilityInfo: tmp,
          targetConversationMessagesConnectionId: ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversation.__id)
        })
      })
    ]
  });
}

let ReplyInput;

let make = ConversationPageConversation;

exports.ReplyInput = ReplyInput;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
